import type { GameLog } from '../../services/interfaces/propsService/api/props';

export type ParsedGameLog = {
  thru?: number;
  golfScore?: string;
};

export function toGolfScore(score: number | undefined | null): string {
  if (!score) return '-';

  const scoreInt = Math.trunc(score);

  if (scoreInt > 0) return `+${scoreInt}`;
  if (scoreInt < 0) return `${scoreInt}`;
  return 'E';
}

export function parseGameLog(gameLog: GameLog | undefined, round: number | undefined): ParsedGameLog {
  if (!gameLog) return {};

  if (round) {
    const matchingRound = gameLog?.rounds?.find((r) => r.round === round);
    return {
      thru: matchingRound?.thru,
      golfScore: matchingRound?.score ? toGolfScore(matchingRound.score) : undefined,
    };
  }

  return {
    thru: gameLog?.thru,
    golfScore: gameLog?.score ? toGolfScore(gameLog?.score) : undefined,
  };
}

export function formatThruScore(thru?: number, golfScore?: string): string | undefined {
  if (thru && golfScore) {
    return `Thru ${thru} (${golfScore})`;
  }
  return undefined;
}
